import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Row from '../../node_modules/reactstrap/esm/Row.js';
import Col from '../../node_modules/reactstrap/esm/Col.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CheckBox from './Checkbox.js';

var _templateObject;
var Content = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  margin: 2px 0;\n"])));
var CheckBoxCols = function CheckBoxCols(_ref) {
  var checkedTypes = _ref.checkedTypes,
    _onChange = _ref.onChange,
    options = _ref.options;
  return /*#__PURE__*/React__default.createElement(Row, null, options.map(function (item, _idx) {
    var checked = checkedTypes.some(function (type) {
      return type.id && type.id === item.id;
    });
    return /*#__PURE__*/React__default.createElement(Col, {
      lg: "6",
      md: "6",
      sm: "6",
      xs: "12",
      key: item.id
    }, /*#__PURE__*/React__default.createElement(Content, null, /*#__PURE__*/React__default.createElement("label", {
      onChange: function onChange() {
        return _onChange(item);
      }
    }, /*#__PURE__*/React__default.createElement(CheckBox, {
      checked: checked
    }), item.title)));
  }));
};
CheckBoxCols.displayName = "CheckBoxCols";
CheckBoxCols.propTypes = {
  checkedTypes: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string
  })),
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string
  })),
  onChange: PropTypes.func
};

export { CheckBoxCols as default };
